/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tut_Presence_S2Inputs */

const en_tut_presence_s2 = /** @type {(inputs: Tut_Presence_S2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Set your own status under **Status saya**: **Otomatis**, **Fokus**, **Rapat**, **Tidak di tempat**, or **Cuti**.`)
};

const id_tut_presence_s2 = /** @type {(inputs: Tut_Presence_S2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Atur status Anda sendiri di bagian **Status saya**: **Otomatis**, **Fokus**, **Rapat**, **Tidak di tempat**, atau **Cuti**.`)
};

/**
* | output |
* | --- |
* | "Set your own status under **Status saya**: **Otomatis**, **Fokus**, **Rapat**, **Tidak di tempat**, or **Cuti**." |
*
* @param {Tut_Presence_S2Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const tut_presence_s2 = /** @type {((inputs?: Tut_Presence_S2Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tut_Presence_S2Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_tut_presence_s2(inputs)
	return en_tut_presence_s2(inputs)
});